export const morePanelId = 'audio-more-panel-id';